import '../../style/index.less';



// WEBPACK FOOTER //
// ./components/icon/style/index.tsx